import {
  isFieldPartIdentifier,
  isFieldGroupPartIdentifier,
  isSectionPartIdentifier,
  isSelectOptionPartIdentifier,
  isSubsectionPartIdentifier,
  PartIdentifier,
} from '@zinnia/form-engine-sdk';

export function arePartIdentifiersTheSame(partIdentifierA: PartIdentifier, partIdentifierB: PartIdentifier): boolean {
  if (partIdentifierA.tag !== partIdentifierB.tag) {
    return false;
  }
  if (isSectionPartIdentifier(partIdentifierA) && isSectionPartIdentifier(partIdentifierB)) {
    return partIdentifierB.sectionPartName === partIdentifierA.sectionPartName;
  }
  if (isSubsectionPartIdentifier(partIdentifierA) && isSubsectionPartIdentifier(partIdentifierB)) {
    return (
      partIdentifierB.sectionPartName === partIdentifierA.sectionPartName &&
      partIdentifierB.subsectionPartName === partIdentifierA.subsectionPartName
    );
  }
  if (isFieldGroupPartIdentifier(partIdentifierA) && isFieldGroupPartIdentifier(partIdentifierB)) {
    return (
      partIdentifierB.sectionPartName === partIdentifierA.sectionPartName &&
      partIdentifierB.subsectionPartName === partIdentifierA.subsectionPartName &&
      partIdentifierB.fieldGroupPartName === partIdentifierA.fieldGroupPartName
    );
  }
  if (isFieldPartIdentifier(partIdentifierA) && isFieldPartIdentifier(partIdentifierB)) {
    return (
      partIdentifierB.sectionPartName === partIdentifierA.sectionPartName &&
      partIdentifierB.subsectionPartName === partIdentifierA.subsectionPartName &&
      partIdentifierB.fieldGroupPartName === partIdentifierA.fieldGroupPartName &&
      partIdentifierB.fieldPartName === partIdentifierA.fieldPartName
    );
  }
  if (isSelectOptionPartIdentifier(partIdentifierA) && isSelectOptionPartIdentifier(partIdentifierB)) {
    return (
      partIdentifierB.sectionPartName === partIdentifierA.sectionPartName &&
      partIdentifierB.subsectionPartName === partIdentifierA.subsectionPartName &&
      partIdentifierB.fieldGroupPartName === partIdentifierA.fieldGroupPartName &&
      partIdentifierB.fieldPartName === partIdentifierA.fieldPartName &&
      partIdentifierB.selectOptionValue === partIdentifierA.selectOptionValue
    );
  }
  return false;
}
